module.exports = __webpack_public_path__ + "static/media/Prosess.a5047254.png";